// extracted by mini-css-extract-plugin
module.exports = {"takeoverProceedButton":"MovingPlannerProceedButton_takeoverProceedButton__1QZhm","loaderContainer":"MovingPlannerProceedButton_loaderContainer__ns1TJ"};